export default __webpack_public_path__ + "static/media/mex.679a9b7e.png";